var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _circle2, _path8, _circle3, _path9, _circle4, _path10, _circle5, _path11, _circle6, _path12, _path13, _circle7, _circle8, _path14, _path15, _path16, _circle9, _circle10, _path17, _path18, _path19, _circle11, _circle12, _path20, _path21, _circle13, _path22, _circle14, _path23, _path24, _circle15, _circle16, _path25, _path26, _path27, _circle17, _circle18, _path28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateMimio2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 172,
    viewBox: "0 0 251 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0628 99.4557C40.2095 106.118 45.2097 112.133 50.7048 117.74C53.5655 120.659 57.114 124.588 61.0572 126.519C73.1372 133.383 100.893 140.954 100.893 140.954C100.893 140.954 131.018 151.238 147.43 150.202C164.503 149.125 179.53 143.861 193.631 133.955C203.039 127.346 213.205 118.711 220.312 109.817C224.295 104.833 237.114 89.2103 236.819 82.8501C236.196 69.4158 224.981 62.1682 215.212 53.0194C213.104 51.0452 206.685 47.9101 206.202 44.7643C205.716 41.5923 204.169 38.1018 201.586 36.106C198.347 33.6041 192.77 33.0372 188.816 34.1338C176.178 37.6383 164.098 41.9378 150.871 41.5579C146.452 41.431 142.436 41.123 138.419 39.1715C132.233 36.1672 126.759 31.8596 120.552 28.9126C111.538 24.6321 97.9005 27.0558 88.4564 29.4775C83.6908 30.6994 79.7823 32.7022 75.5054 35.1188C68.5078 39.0728 61.2523 42.7789 54.7798 47.5675C50.0742 51.049 40.4856 56.6258 37.0447 60.9756C28.5057 71.7698 29.4216 88.7855 36.0628 99.4557Z",
    fill: "#FEC2C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.131 87.8525L186.535 119.399",
    stroke: "black",
    strokeWidth: 1.25485
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.727 98.1393L72.6938 111.169",
    stroke: "black",
    strokeWidth: 1.25485
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.098 75.5082L71.3223 46.0191",
    stroke: "black",
    strokeWidth: 1.25485
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.361 75.5082L183.792 59.735",
    stroke: "black",
    strokeWidth: 1.25485
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5976 111.45L26.9932 95.8852",
    stroke: "black",
    strokeWidth: 1.25485
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.8611,
    cy: 90.6436,
    r: 9.29395,
    transform: "rotate(19.0464 21.8611 90.6436)",
    fill: "#FF8793"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.56 131.818L150.384 135.298",
    stroke: "black",
    strokeWidth: 1.25485
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.658,
    cy: 135.263,
    r: 9.29395,
    transform: "rotate(-21.8351 143.658 135.263)",
    fill: "#FF8793"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M213.975 63.942L220.384 75.2974",
    stroke: "black",
    strokeWidth: 1.25485
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.29395,
    cy: 9.29395,
    r: 9.29395,
    transform: "matrix(-0.185791 -0.982589 -0.982589 0.185791 235.685 88.5396)",
    fill: "#FF8793"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.029 116.15L201.363 103.544",
    stroke: "black",
    strokeWidth: 1.25485
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.29395,
    cy: 9.29395,
    r: 9.29395,
    transform: "matrix(-0.552621 0.833433 0.833433 0.552621 199.644 83.382)",
    fill: "#FF8793"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0094 130.459L94.7959 130.453",
    stroke: "black",
    strokeWidth: 1.25485
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.249,
    cy: 130.356,
    r: 9.29395,
    transform: "rotate(161.242 104.249 130.356)",
    fill: "#FF8793"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.246 45.5446L154.564 45.1553",
    stroke: "black",
    strokeWidth: 1.25485
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.29395,
    cy: 9.29395,
    r: 9.29395,
    transform: "matrix(0.994695 0.102869 0.102869 -0.994695 135.314 52.7516)",
    fill: "#FF8793"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.72 117.832C177.754 120.286 177.798 123.752 178.037 125.737C178.524 129.78 178.348 131.704 181.189 135.458C186.621 142.635 197.917 142.941 205.471 139.214C207.618 138.154 208.121 134.222 209.756 133.077C215.696 128.913 210.327 124.621 209.863 119.057C208.504 114.622 201.302 110.605 198.74 110.818C194.048 111.21 192.626 112.355 187.512 114.555C184.48 115.86 181.792 115.244 179.72 117.832Z",
    fill: "#3DA7E7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M184.551 120.495C183.198 122.184 183.228 124.57 183.393 125.937C183.728 128.719 183.607 130.044 185.562 132.628C189.301 137.568 197.076 137.778 202.276 135.213C203.753 134.484 204.1 131.777 205.225 130.988C209.314 128.123 205.618 125.169 205.299 121.339C204.363 118.286 199.406 115.521 197.643 115.668C194.413 115.937 193.434 116.726 189.915 118.24C187.827 119.138 185.977 118.714 184.551 120.495Z",
    fill: "#4ABBFF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.58937,
    cy: 1.58937,
    r: 1.58937,
    transform: "matrix(-1 0 0 1 202.235 124.08)",
    fill: "#2C2727"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.58937,
    cy: 1.58937,
    r: 1.58937,
    transform: "matrix(-1 0 0 1 191.427 124.08)",
    fill: "#2C2727"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M192.592 127.26C192.592 128.533 193.778 129.485 195.135 129.485C196.491 129.485 197.678 128.533 197.678 127.26",
    stroke: "black",
    strokeWidth: 1.37158
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6833 107.212C78.3166 110.5 78.2577 115.142 77.9374 117.802C77.2853 123.218 77.5208 125.795 73.715 130.824C66.4388 140.439 53.3945 142.784 43.2761 137.791C40.4001 136.372 35.5219 133.391 33.1705 128.604C29.7504 121.641 31.3331 116.661 35.3028 108.854C37.1244 102.912 46.7719 97.531 50.2035 97.8171C56.4895 98.3411 57.5576 97.1777 64.4078 100.125C68.4705 101.872 72.907 103.746 75.6833 107.212Z",
    fill: "#3DA7E7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2106 110.78C71.0231 113.043 70.9826 116.239 70.7621 118.069C70.3133 121.798 70.4754 123.571 67.8558 127.033C62.8474 133.65 52.431 133.933 45.4664 130.496C36.7158 126.178 37.9466 118.479 41.4161 111.91C43.7441 107.503 49.3104 104.117 51.6724 104.314C55.9992 104.674 57.853 103.608 62.5681 105.637C65.3645 106.84 67.2996 108.394 69.2106 110.78Z",
    fill: "#4ABBFF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.12913,
    cy: 2.12913,
    r: 2.12913,
    transform: "matrix(-1 0 0 1 64.3101 115.582)",
    fill: "#2C2727"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.12913,
    cy: 2.12913,
    r: 2.12913,
    transform: "matrix(-1 0 0 1 49.832 115.582)",
    fill: "#2C2727"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3924 119.842C51.3924 121.548 52.9815 122.823 54.799 122.823C56.6164 122.823 58.2056 121.548 58.2056 119.842",
    stroke: "black",
    strokeWidth: 1.37158
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M217.313 38.6329C219.946 41.9205 219.887 46.5631 219.567 49.2229C218.915 54.6391 219.15 57.2163 215.344 62.245C208.068 71.8593 195.024 74.2046 184.905 69.2118C182.03 67.7927 177.151 64.8121 174.8 60.0249C171.38 53.0618 172.963 48.0819 176.932 40.2749C178.754 34.3333 188.401 28.9518 191.833 29.2379C198.119 29.7619 199.187 28.5985 206.037 31.5454C210.1 33.2932 214.536 35.1668 217.313 38.6329Z",
    fill: "#3DA7E7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M210.84 42.201C212.653 44.4639 212.612 47.6595 212.392 49.4902C211.943 53.2183 212.105 54.9922 209.485 58.4535C204.477 65.0713 194.06 65.3534 187.096 61.9167C178.345 57.5988 179.576 49.8996 183.045 43.3312C185.374 38.9238 190.94 35.5374 193.302 35.7343C197.629 36.0949 199.482 35.0292 204.197 37.0576C206.994 38.2606 208.929 39.8152 210.84 42.201Z",
    fill: "#4ABBFF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.12913,
    cy: 2.12913,
    r: 2.12913,
    transform: "matrix(-1 0 0 1 205.939 47.0026)",
    fill: "#2C2727"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.12913,
    cy: 2.12913,
    r: 2.12913,
    transform: "matrix(-1 0 0 1 191.461 47.0026)",
    fill: "#2C2727"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M193.022 51.2631C193.022 52.9686 194.611 54.2439 196.428 54.2439C198.246 54.2439 199.835 52.9686 199.835 51.2631",
    stroke: "black",
    strokeWidth: 1.37158
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7214 41.1865L101.708 34.6975",
    stroke: "black",
    strokeWidth: 1.25485
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.159,
    cy: 32.7287,
    r: 10.6663,
    transform: "rotate(179.752 112.159 32.7287)",
    fill: "#FF8793"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8205 59.954L67.793 74.8869",
    stroke: "black",
    strokeWidth: 1.25485
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.1911,
    cy: 83.2833,
    r: 10.6663,
    transform: "rotate(-112.46 67.1911 83.2833)",
    fill: "#FF8793"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0243 40.1501C83.9901 42.6043 83.9461 46.07 83.707 48.0554C83.2202 52.0985 83.396 54.0224 80.555 57.7763C75.1234 64.9533 63.8267 65.2593 56.2734 61.5321C54.1265 60.4728 53.6234 56.5409 51.9885 55.395C46.0481 51.2316 51.417 46.9397 51.8808 41.3758C53.2406 36.9405 60.4423 32.9233 63.0039 33.1368C67.6964 33.528 69.1181 34.6734 74.2317 36.8733C77.2645 38.178 79.9518 37.5627 82.0243 40.1501Z",
    fill: "#3DA7E7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1929 42.8136C78.5459 44.5029 78.5157 46.8883 78.3511 48.255C78.016 51.0379 78.137 52.3621 76.1816 54.946C72.4429 59.886 64.6672 60.0966 59.4681 57.5312C57.9904 56.802 57.6441 54.0956 56.5188 53.3069C52.4299 50.4412 56.1254 47.487 56.4446 43.6573C57.3806 40.6044 62.3377 37.8393 64.1009 37.9863C67.3307 38.2555 68.3093 39.0439 71.8291 40.5581C73.9166 41.4562 75.7664 41.0327 77.1929 42.8136Z",
    fill: "#4ABBFF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.58937,
    cy: 1.58937,
    r: 1.58937,
    transform: "matrix(-1 0 0 1 73.5337 46.398)",
    fill: "#2C2727"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.58937,
    cy: 1.58937,
    r: 1.58937,
    transform: "matrix(-1 0 0 1 62.7256 46.3979)",
    fill: "#2C2727"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8901 49.5784C63.8901 50.8515 65.0764 51.8035 66.4331 51.8035C67.7898 51.8035 68.9761 50.8515 68.9761 49.5784",
    stroke: "black",
    strokeWidth: 1.37158
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M108.393 111.807C103.655 108.555 101.897 102.469 101.264 98.8695C99.9751 91.5394 98.649 88.2673 101.631 80.1969C107.333 64.767 126.931 58.251 142.117 60.7717C146.433 61.4881 149.395 68.0996 152.861 69.2384C165.456 73.3761 158.337 83.726 160.472 93.704C160.441 102.182 149.971 113.022 145.377 114.005C136.961 115.805 133.868 114.554 123.759 113.413C117.763 112.737 113.388 115.236 108.393 111.807Z",
    fill: "#3DA7E7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M115.434 104.59C112.173 102.351 110.963 98.1626 110.527 95.6849C109.64 90.6395 108.727 88.3873 110.78 82.8323C114.704 72.2117 128.194 67.7266 138.647 69.4616C141.618 69.9548 143.656 74.5055 146.042 75.2894C154.712 78.1374 149.811 85.2614 151.281 92.1294C151.26 97.9652 144.053 105.426 140.89 106.103C135.098 107.342 132.969 106.481 126.01 105.695C121.884 105.23 118.872 106.95 115.434 104.59Z",
    fill: "#4ABBFF"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.90471,
    cy: 2.90471,
    r: 2.90471,
    transform: "matrix(-1 0 0 1 143.801 81.9471)",
    fill: "#2C2727"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.90471,
    cy: 2.90471,
    r: 2.90471,
    transform: "matrix(-1 0 0 1 124.049 81.947)",
    fill: "#2C2727"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.31 87.7595H127.338H126.177C126.177 90.0862 128.345 91.8261 130.824 91.8261C133.304 91.8261 135.472 90.0862 135.472 87.7595H134.31Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateMimio2);
export default __webpack_public_path__ + "static/media/create-mimio-2.cb53b5267a375132578a7eca8e8c898e.svg";
export { ForwardRef as ReactComponent };